export const itemsNavbar = [
  {
    to: "/",
    title: "Inicio",
    className: "nav-link text-uppercase nl-link",
  },
  {
    to: "/quien_somos",
    title: "Quienes Somos",
    className: "nav-link text-uppercase nl-link",
  },
  {
    to: "/servicios",
    title: "Servicios",
    className: "nav-link text-uppercase nl-link menu_hover",
    subItems: true,
  },
  {
    to: "/contacto",
    title: "Contacto",
    className: "btn text-uppercase btn-link",
  },
];
